import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/index';
import * as fromCommonStore from '../store';



@Injectable()
export class AuthGuard implements CanActivate {
    isauth$: Observable<any>;
    constructor(private store: Store<fromCommonStore.State>, private router: Router, private authService: AuthService) { 
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            this.isauth$ = auth;
            //console.log(this.isauth$);
            //
            if(auth.length==0){
                return;
            }
            if(this.isauth$['islogin']){
                this.router.navigate([''], { skipLocationChange: true});
            }else{
                this.router.navigate(['login'], { skipLocationChange: true});
            }
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        //console.log(this.isauth$);
        if (this.isauth$) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        //this.router.navigate(['login'], { skipLocationChange: true});
        return false;
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/guards/auth.guard.ts